import { EncryptService } from './encrypt.service';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated = false;
  private token = '';
  private tokenTimer: any;
  private userRole = 'basic';
  private userID = '';
  private authStatusListener = new Subject<boolean>();

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private encryptService: EncryptService
  ) {}

  getToken(): string {
    return this.token;
  }

  getUserRole(): string {
    return this.userRole;
  }

  getUserID(): string {
    return this.userID;
  }

  getIsAuth(): boolean {
    return this.isAuthenticated;
  }

  getAuthStatusListener(): Observable<boolean> {
    return this.authStatusListener.asObservable();
  }

  createUser(
    firstname: string,
    surname: string,
    email: string,
    password: string
  ): void {
    const userData = {
      firstname,
      surname,
      email,
      password,
    };
    console.log('Registrando usuario: ', userData);

    this.httpClient
      .post(environment.apiURL + '/user/signup', userData)
      .subscribe(
        (response) => {
          console.log(response);
          this.router.navigate(['/iniciar-sesion'], {
            state: {
              data: 'Gracias por registrase. Podrá acceder cuando validemos su cuenta.',
            },
          });
        },
        (err) => {
          console.log(err);
          this.authStatusListener.next(false);
        }
      );
  }

  login(email: string, password: string): void {
    const userData = {
      email,
      password,
    };
    console.log('Iniciando sesión con usuario: ', userData);

    this.httpClient
      .post<{
        token: string;
        user_id: string;
        role: string;
        expiresIn: number;
      }>(environment.apiURL + '/user/login', userData)
      .subscribe(
        (response) => {
          console.log('Usuario autenticado: ', response);
          this.token = response.token;
          if (this.token) {
            this.setAuthTimer(response.expiresIn);
            console.log(response.expiresIn);
            this.authStatusListener.next(true);
            this.isAuthenticated = true;
            this.userRole = response.role;
            this.userID = response.user_id;
            this.saveAuthData(
              this.token,
              this.userID,
              this.userRole,
              // Se calcula la fecha y hora en que caduca el token
              new Date(Date.now() + Number(response.expiresIn))
            );
            this.router.navigate(['/']);
          }
        },
        (err) => {
          console.log('Error en login', err);
          if (
            err.error &&
            err.error &&
            err.error.error &&
            err.error.error.message
          ) {
            alert(err.error.error.message);
          } else {
            alert('Se ha producido un error al procesar este usuario/a.');
          }
          this.authStatusListener.next(false);
        }
      );
  }

  autoAuthUser(): void {
    const authInformation = this.getAuthData();
    console.log('Auto AuthInformation: ', authInformation);
    if (!authInformation) {
      this.router.navigate(['/iniciar-sesion']);
      return;
    } else {
      // expiresIn in ms
      const expiresIn =
        authInformation.expirationDate.getTime() - new Date().getTime();
      if (expiresIn > 0) {
        console.log('User is auto logged from local storage info: ', expiresIn);
        this.token = authInformation.token;
        this.isAuthenticated = true;
        this.userRole = authInformation.role;
        this.userID = authInformation.user_id;
        this.authStatusListener.next(true);
        this.setAuthTimer(expiresIn);
      } else {
        console.log(
          'User IS NOT auto logged from local storage info',
          expiresIn
        );
        this.isAuthenticated = false;
      }
    }
  }

  logout(message: string): void {
    console.log('Logging out...');
    this.token = '';
    this.userRole = 'basic';
    this.userID = '';
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    clearTimeout(this.tokenTimer);
    this.clearAuthData();

    if (message) {
      this.router.navigate(['/iniciar-sesion'], { state: { data: message } });
    } else {
      this.router.navigate(['/iniciar-sesion']);
    }
  }

  private setAuthTimer(duration: number): void {
    this.tokenTimer = setTimeout(() => {
      this.logout('Su sesión ha caducado. Por favor, inicie sesión de nuevo.');
    }, duration);
  }

  private getAuthData(): {
    token: string;
    user_id: string;
    role: string;
    expirationDate: Date;
  } | null {
    let token = localStorage.getItem('token');
    let userID = localStorage.getItem('user_id');
    let role = localStorage.getItem('role');
    let expirationDate = localStorage.getItem('expirationDate');

    token = token ? this.encryptService.decrypt(token) : '';
    userID = userID ? this.encryptService.decrypt(userID) : '';
    role = role ? this.encryptService.decrypt(role) : '';
    expirationDate = expirationDate
      ? this.encryptService.decrypt(expirationDate)
      : '';

    if (!token || !expirationDate || token === '' || expirationDate === '') {
      return null;
    }
    console.log('USERID from localstorage: ', userID);
    return {
      token,
      user_id: userID,
      role,
      expirationDate: new Date(expirationDate),
    };
  }

  private saveAuthData(
    token: string,
    userID: string,
    role: string,
    expirationDate: Date
  ): void {
    console.log('Saving userID: ', userID);
    localStorage.setItem('token', this.encryptService.encrypt(token));
    localStorage.setItem('user_id', this.encryptService.encrypt(userID));
    localStorage.setItem('role', this.encryptService.encrypt(role));
    localStorage.setItem(
      'expirationDate',
      this.encryptService.encrypt(expirationDate.toISOString())
    );
  }

  private clearAuthData(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('expirationDate');
  }
}
